import { DatePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  PaymentProfileStatus,
  AdvisorIncentiveWorkshopName
} from '../../../../models/_enum-collections';
import { IncentiveDetails } from '../../../../models/incentive-details.model';
import { CommonSharedModule } from '../../../common/shared.module';

@Component({
  selector: 'app-incentive-payment-info',
  templateUrl: './incentive-payment-info.component.html',
  styleUrls: ['./incentive-payment-info.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class IncentivePaymentInfoComponent implements OnInit {
  @Input() incentiveDetails!: IncentiveDetails;
  formPaymentInfo!: FormGroup;
  datePipe = new DatePipe('en-US');
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.getForms();
    this.getPaymentInfo();
  }

  getForms() {
    this.formPaymentInfo = this.formBuilder.group({
      preSaleActivityDate: [''],
      partnerPaymentProfileStatus: [''],
      supplierID: [''],
      payeeID: [''],
      payeeName: [''],
      agreement: ['']
    });
  }

  getPaymentInfo() {
    if (!this.isMCIWorkshop) {
      this.formPaymentInfo.controls['partnerPaymentProfileStatus'].setValue(
        this.incentiveDetails.partnerPaymentProfileStatus === true
          ? 'true'
          : 'false'
      );

      this.formPaymentInfo.controls['agreement'].setValue(
        this.incentiveDetails.agreement === true ? 'true' : 'false'
      );

      this.formPaymentInfo.patchValue({
        supplierID: this.incentiveDetails.supplierID,
        payeeID: this.incentiveDetails.payeeID,
        payeeName: this.incentiveDetails.payeeName
      });
    }
    this.formPaymentInfo.patchValue({
      preSaleActivityDate: this.datePipe.transform(
        this.incentiveDetails.workshopCompletionDate,
        'MM/dd/yyyy'
      )
    });
  }

  get PaymentProfileStatus() {
    return PaymentProfileStatus;
  }

  get isMCIWorkshop() {
    return this.incentiveDetails.deliveryName ===
      AdvisorIncentiveWorkshopName.Frontline_Worker_MCI ||
      this.incentiveDetails.deliveryName ===
        AdvisorIncentiveWorkshopName.Microsoft_Viva_MCI
      ? true
      : false;
  }
}
